import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedTenantId, setSelectedTenantId] = useState(null);
  const [selectedTenantName, setSelectedTenantName] = useState(null);

  useEffect(() => {
    // Set default tenant based on user role
    if (user) {
      if (user.role === 'tenant_user') {
        // Tenant users can only see their own tenant
        setSelectedTenantId(user.tenant_id);
        setSelectedTenantName(null);
      } else if (user.role === 'all_external') {
        // All External can see all non-NKE tenants - default to "all"
        setSelectedTenantId(null);
        setSelectedTenantName(null);
      } else if (user.role === 'admin' || user.role === 'qhse_nke') {
        // Admin/NKE can see all tenants - default to "all"
        setSelectedTenantId(null);
        setSelectedTenantName(null);
      }
    }
  }, [user]);

  const setTenantSelection = (id, name) => {
    setSelectedTenantId(id);
    setSelectedTenantName(name || null);
  };

  const value = {
    selectedTenantId,
    selectedTenantName,
    setTenantSelection,
    canSelectTenant: user?.role === 'admin' || user?.role === 'qhse_nke' || user?.role === 'all_external',
  };

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};
